import { io, Socket } from 'socket.io-client'

// The API base may include a trailing /api; the Socket.IO server lives at the ORIGIN, so strip it.
const SOCKET_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5000').replace(/\/api\/?$/, '')

class SocketService {
  private socket: Socket | null = null
  private listeners: Map<string, Set<Function>> = new Map()

  connect(userId: string = '', role: string = '', name: string = '') {
    if (this.socket?.connected) {
      return this.socket
    }

    const token = (typeof localStorage !== 'undefined' && localStorage.getItem('token')) || ''

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      auth: token ? { token } : {},
    })

    this.socket.on('connect', () => {
      console.log('Socket connected')
      this.socket?.emit('authenticate', { userId, role, name })
      // (Re)subscribe to live inventory changes on every (re)connect
      this.socket?.emit('inventory:subscribe')
    })

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected')
    })

    // Re-register all listeners
    this.listeners.forEach((callbacks, event) => {
      callbacks.forEach((callback) => {
        this.socket?.on(event, callback as any)
      })
    })

    return this.socket
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  on<T = any>(event: string, callback: (data: T) => void) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)?.add(callback)

    if (this.socket) {
      this.socket.on(event, callback as any)
    }
  }

  off(event: string, callback?: Function) {
    if (callback) {
      this.listeners.get(event)?.delete(callback)
      if (this.socket) {
        this.socket.off(event, callback as any)
      }
    } else {
      this.listeners.delete(event)
      if (this.socket) {
        this.socket.off(event)
      }
    }
  }

  emit(event: string, data?: any) {
    if (this.socket) {
      this.socket.emit(event, data)
    }
  }

  isConnected(): boolean {
    return this.socket?.connected || false
  }
}

export const socketService = new SocketService()


